import { memo } from 'react'

function ShowCars({ editCustomer, customer }) {
  return (
    <button onClick={() => editCustomer(customer)} className="font-medium text-link dark:text-link">
      مشاهده خودروها
    </button>
  )
}

export default memo(ShowCars)
